import { ISvgProps, Svg } from '@components';
import { memo } from 'react';

export const EnvelopeIcon = memo<ISvgProps>((props, { className }) => (
  <Svg className={className} width="24" height="19" viewBox="0 0 24 19" {...props}>
    <path
      id="Path_21260"
      data-name="Path 21260"
      d="M19,1H5C2.24,1,0,2.935,0,5.318V15.682C0,18.066,2.24,20,5,20H19c2.76,0,5-1.935,5-4.318V5.318C24,2.935,21.76,1,19,1ZM5,2.727H19a3.03,3.03,0,0,1,2.78,1.63l-7.658,6.615a3.353,3.353,0,0,1-4.244,0L2.22,4.357A3.03,3.03,0,0,1,5,2.727ZM19,18.273H5a2.818,2.818,0,0,1-3-2.591V6.614l6.464,5.579a5.582,5.582,0,0,0,7.072,0L22,6.614v9.068A2.818,2.818,0,0,1,19,18.273Z"
      transform="translate(0 -1)"
      fill="#fff"
    />
  </Svg>
));

EnvelopeIcon.displayName = 'EnvelopeIcon';

export default EnvelopeIcon;
